import { render, staticRenderFns } from "./boardAllLeft.vue?vue&type=template&id=6a6c4566&scoped=true&"
import script from "./boardAllLeft.vue?vue&type=script&lang=js&"
export * from "./boardAllLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6c4566",
  null
  
)

export default component.exports